import React from "react";

import TransactionTable from "../../../ass_components/account/business/TransactionTable";
import useMyTransactions from "../../../hooks/useMyTransactions";

const Sales = () => {
    const { sales, loading, error, userId } = useMyTransactions();

    return (
        <TransactionTable
            title="Mes ventes"
            transactions={sales}
            loading={loading}
            error={error}
            userId={userId}
            emptyText="Aucune vente pour le moment"
        />
    );
};

export default Sales;
